export const FEIN_REGEXP = /^[\d-]{9,10}$/;
